import { render, staticRenderFns } from "./master-package-payment-partner.vue?vue&type=template&id=5ed2dddf"
import script from "./master-package-payment-partner.vue?vue&type=script&lang=js"
export * from "./master-package-payment-partner.vue?vue&type=script&lang=js"
import style0 from "./master-package-payment-partner.vue?vue&type=style&index=0&id=5ed2dddf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports